// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3BhJw","text":"SelectPayment_text__3VQnE","title":"SelectPayment_title__3rQnV","btn":"SelectPayment_btn__IJMhe"};